module.exports = __webpack_public_path__ + "img/fuw-logo.83b43e03.svg";